import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Arbeitsbereich} from "../../../config/model/arbeitsbereich-config.model";

@Injectable({
  providedIn: 'root',
})
export class WorkspaceNotifyService {
  private readonly selectWorkSpaceBehaviorSubject: BehaviorSubject<Arbeitsbereich> = new BehaviorSubject(null);
  private readonly onWorkspaceChangedSubject: Subject<boolean> = new Subject();

  get selectWorkspace$(): Observable<Arbeitsbereich> {
    return this.selectWorkSpaceBehaviorSubject.asObservable();
  }

  get onWorkspaceChangedCompleted(): Observable<boolean> {
    return this.onWorkspaceChangedSubject.asObservable();
  }

  constructor() {}

  public setWorkspace(ws: Arbeitsbereich) {
    this.selectWorkSpaceBehaviorSubject.next(ws);
  }

  public onWorkspaceChanged(isChanged: boolean) {
    this.onWorkspaceChangedSubject.next(isChanged);
  }

}
